const { i18nConfig } = require('@shared/locales')

module.exports = i18nConfig
